export const LeashRoutes = {
  Dashboard: `/leash/dashboard`,
  Packages: `/leash/packages`,
  Details: `/leash/details`,
  Archived: `/leash/packages/archived`,
} as const;

export const TravelMethodId = {
  Meetup: 1,
  GroundTransportation: 2,
  CommercialCargo: 3,
  CharterFlight: 4,
  Chaperone: 5,
  LocalDelivery: 6,
  HubPassThru: 7,
} as const;

export const TravelTypeId = {
  Meetup: 10,
  PickNearHome: 15,
  HomeDelivery: 16,
  ChaperoneAirportDelivery: 17,
  ChaperoneHomeDelivery: 18,
} as const;

export const PackageSearchCategory = {
  PuppyId: 'puppy.id',
  BreederId: 'breeder.id',
  ContactId: 'leadId',
  Breed: 'puppy.breed',
  BreederName: 'breeder.name',
  Airport: 'originAirportName',
  Airline: 'airlineName',
  Transporter: 'firstMileTransporterCompanyName',
  GroundTransporter: 'groundTransportationCompanyName',
} as const;
